import { useSetAtom } from 'jotai';
import { writeSecretAtom, writeSessionAtom } from '../atoms/auth';
import { IS_MOCK } from '../lib/api';
import { useLocation } from 'wouter';
import { Link } from 'wouter';

const NAV = [
  { name: 'Dashboard',     path: '/',             icon: 'fa-solid fa-chart-simple' },
  { name: 'OptimaLink',    path: '/optimaLink',   icon: 'fa-solid fa-music'        },
  { name: 'The Backrooms', path: '/backrooms',    icon: 'fa-solid fa-file-lines'   },
  { name: 'Config',        path: '/fivem-config', icon: 'fa-solid fa-sliders'      },
  { name: 'API Keys',      path: '/apikeys',      icon: 'fa-solid fa-key'          },
];

export function Sidebar() {
  const [location] = useLocation();
  const setSecret  = useSetAtom(writeSecretAtom);
  const setSession = useSetAtom(writeSessionAtom);

  const handleLogout = () => {
    setSecret(null);
    setSession(null);
    window.location.href = '/panel/login';
  };

  return (
    <aside className="relative w-[220px] shrink-0 h-screen sticky top-0 flex flex-col z-20 overflow-hidden bg-[#070910] border-r border-white/[0.05]">
      {/* Cipher backdrop */}
      <div className="cipher-backdrop absolute inset-0 font-mono text-[9px] text-cyberGreen/[0.04] select-none pointer-events-none overflow-hidden z-0 p-4 leading-none tracking-widest break-all opacity-60">
        {Array.from({ length: 20 }).map((_, i) => (
          <div key={i}>SC_LABS_OWNER_PANEL_v2_SECURE_ACCESS_GRANTED_2026_</div>
        ))}
      </div>

      {/* ── Brand header ── */}
      <div className="relative z-10 h-[72px] px-5 flex items-center gap-3 border-b border-white/[0.05]">
        <div className="relative w-9 h-9 flex items-center justify-center shrink-0">
          <div className="absolute inset-0 rounded-full border border-cyberGreen/20 animate-pulse" />
          <div className="w-7 h-7 rounded-full bg-cyberGreen/10 border border-cyberGreen/30 flex items-center justify-center shadow-[0_0_14px_rgba(0,255,102,0.2)]">
            <i className="fa-solid fa-shield-halved text-[11px] text-cyberGreen" />
          </div>
        </div>
        <div>
          <div className="font-black text-[13px] tracking-tight text-white uppercase leading-none">
            SC <span className="text-cyberGreen neon-text-glow">Labs</span>
          </div>
          <div className="text-[9px] font-mono text-slate-500 tracking-[0.15em] mt-0.5">COMMAND DECK</div>
        </div>
        {IS_MOCK && (
          <span className="ml-auto text-[8px] font-mono font-bold tracking-widest text-amber-400/80 bg-amber-400/10 border border-amber-400/20 px-1.5 py-0.5 rounded">
            MOCK
          </span>
        )}
      </div>

      {/* ── Nav ── */}
      <nav className="relative z-10 flex-1 px-3 py-4 flex flex-col gap-0.5 overflow-y-auto">
        {NAV.map(item => {
          const isActive = location === item.path || (item.path !== '/' && location.startsWith(item.path));
          return (
            <Link key={item.path} href={item.path} asChild>
              <a
                className={`panel-nav-btn relative flex items-center gap-3 px-3 py-2.5 rounded-xl text-[11px] font-semibold cursor-pointer select-none border
                  ${isActive
                    ? 'active bg-cyberGreen/[0.06] text-cyberGreen border-cyberGreen/15 shadow-[inset_0_0_12px_rgba(0,255,102,0.04)]'
                    : 'text-slate-400 hover:text-slate-200 hover:bg-white/[0.03] border-transparent'
                  }`}
              >
                {isActive && (
                  <div className="absolute left-0 top-1/2 -translate-y-1/2 w-[2px] h-5 bg-cyberGreen rounded-r-full shadow-[0_0_8px_#00ff66]" />
                )}
                <i
                  className={`${item.icon} text-[12px] w-4 text-center ${isActive ? 'text-cyberGreen drop-shadow-[0_0_6px_rgba(0,255,102,0.8)]' : 'text-slate-600'}`}
                />
                <span className="truncate">{item.name}</span>
              </a>
            </Link>
          );
        })}
      </nav>

      {/* ── Footer ── */}
      <div className="relative z-10 p-3 border-t border-white/[0.04] flex flex-col gap-2">
        <div className="px-3 py-2 rounded-xl bg-white/[0.02] border border-white/[0.04] flex items-center gap-2">
          <span className="relative flex h-1.5 w-1.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cyberGreen opacity-75" />
            <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-cyberGreen" />
          </span>
          <span className="text-[9px] font-mono text-slate-500">SC Labs Bot</span>
          <span className="ml-auto text-[9px] font-mono text-cyberGreen/60 neon-text-glow">ONLINE</span>
        </div>
        {!IS_MOCK && (
          <button
            onClick={handleLogout}
            className="w-full flex items-center justify-center gap-2 px-3 py-2 rounded-xl text-[10px] font-bold uppercase tracking-wider text-red-400/70 hover:text-red-300 hover:bg-red-500/[0.07] border border-transparent hover:border-red-500/15 transition-all"
          >
            <i className="fa-solid fa-right-from-bracket text-xs" />
            Logout
          </button>
        )}
      </div>
    </aside>
  );
}
